import { render, staticRenderFns } from "./TaxonomyItem.vue?vue&type=template&id=ef8f7918&scoped=true&"
import script from "./TaxonomyItem.vue?vue&type=script&lang=js&"
export * from "./TaxonomyItem.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyItem.vue?vue&type=style&index=0&id=ef8f7918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8f7918",
  null
  
)

export default component.exports